import React, { useRef, useState } from "react";
import gsap from "gsap";
import { useGSAP } from "@gsap/react";
import { CiLinkedin } from "react-icons/ci";
import { FaGithub } from "react-icons/fa";

gsap.registerPlugin(useGSAP);

export default function ContactCard({lang, langOptions}) {
  const cardRef = useRef();

  const animationFrameRef = useRef(null);

  const links = {
    email: "n.socrate@outlook.com",
    linkedin: "https://fr.linkedin.com/in/nina-socrate-82a9a9193",
    gitHub: "https://github.com/Ouadjet2807",
  }

  const handleCard = async (e) => {
    const card = cardRef.current;

    if (!card) {
      return;
    } else {
      const cardRect = card.getBoundingClientRect();
      const width = cardRect.width;
      const height = cardRect.height;
      const midWidth = width / 2;
      const midHeight = height / 2;

      // Position de la souris par rapport à la carte
      const cursPosX = e.clientX - cardRect.left;
      const cursPosY = e.clientY - cardRect.top;

      // Distance par rapport au centre de la carte
      const cursCenterX = midWidth - cursPosX;
      const cursCenterY = midHeight - cursPosY;

      // Calcul des transformations
      const delta = 20; // Intensité de l'effet
      const perspective = "500px";

      if (animationFrameRef.current) {
        cancelAnimationFrame(animationFrameRef.current);
      }

      animationFrameRef.current = requestAnimationFrame(() => {
        card.style.transform = `perspective(${perspective}) rotateX(${
          cursCenterY / delta
        }deg) rotateY(${-cursCenterX / delta}deg)`;
        card.classList.remove("is-out");
      });
    }
  };

  const handleCardLeave = () => {
    const card = cardRef.current;

    if (!card) return;
    if (animationFrameRef.current) {
      cancelAnimationFrame(animationFrameRef.current);
    }
    card.style.transform = ""; // Réinitialise les transformations
    card.classList.add("is-out"); // Ajoute une classe pour un éventuel effet CSS
  };

  return (
    <div
      className="card"
      ref={cardRef}
      onMouseMove={(e) => handleCard(e)}
      onMouseLeave={() => handleCardLeave()}
    >
      <button className="hover-target"><a href={`mailto:${links.email}`}>{langOptions.contact[lang]}</a></button>
      <div className="socials">
        <a
          href={links.linkedin}
          className="social hover-target" 
          target="blank"
        >
          <CiLinkedin />
        </a>
        <a
          href={links.gitHub}
          className="social hover-target"
          target="blank"
        >
          <FaGithub />
        </a>
      </div>
    </div>
  );
}
